import { Dispatch } from 'redux';

import * as SkillDetailActions from '../actions/skillDetail';
import AbstractScenario from './AbstractScenario';

export default class SkillDetailScenarioFactory {
	/**
	 * スキル詳細情報画面初期化データ取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchSkillDetail(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<string> {
			protected process(skillId: string) {
				// 初期化
				this.dispatch(
					SkillDetailActions.setSkillDetail({
						skillInfo: {
							skillId: '',
						},
					})
				);

				// データ取得
				const doScenario = SkillDetailScenarioFactory.createDoFetchSkillDetail(
					this.dispatch,
					this.token
				);
				return doScenario.run(skillId).then(data => {
					this.dispatch(SkillDetailActions.setSkillDetail(data));
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * スキル情報取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createDoFetchSkillDetail(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<string> {
			protected process(skillId: string) {
				const param = {
					accessType: 10,
					skillId,
				};
				return this.read(
					'com_skill_SkillInfoDetailBlockModel',
					param
				).then(data => ({
					skillInfo: data as SkillDetailActions.ISkillDetail,
				}));
			}
		}(dispatch, token);
		return scenario;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/SkillDetailScenarioFactory.ts